module.exports = __webpack_public_path__ + "img/money.69115d62.svg";